import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateExpedienteReclamoRequest } from '@models/expedienteReclamo/createExpedienteReclamoRequest.model';
import { ExpedienteReclamoDto } from '@models/expedienteReclamo/expedienteExpedienteReclamoDto.model';
import { UpdateExpedienteReclamoRequest } from '@models/expedienteReclamo/updateExpedienteReclamoRequest.model';
import { CreateExpedienteVinculadoRequest } from '@models/expedienteVinculado/createExpedienteVinculadoRequest.model';
import { ExpedienteVinculadoDto } from '@models/expedienteVinculado/expedienteVinculadoDto.model';
import { UpdateExpedienteVinculadoRequest } from '@models/expedienteVinculado/updateExpedienteVinculadoRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class ExpedienteVinculadoService {

  constructor(private http:HttpClient) {
  }

  create(createExpedienteVinculadoRequest:CreateExpedienteVinculadoRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/ExpedienteVinculado/Create",createExpedienteVinculadoRequest);
  }

  update(updateExpedienteVinculadoRequest:UpdateExpedienteVinculadoRequest):Observable<any>
  {
    return  this.http.put<any>("/api/ExpedienteVinculado/Update",updateExpedienteVinculadoRequest);
  }

  getAll():Observable<ExpedienteVinculadoDto[]> {
    return   this.http.get<ExpedienteVinculadoDto[]>("/api/ExpedienteVinculado/GetAll");
  }

   getAllByIdExpediente(idExpediente:number):Observable<ExpedienteVinculadoDto[]> {
    return   this.http.get<ExpedienteVinculadoDto[]>("/api/ExpedienteVinculado/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getById(id:number):Observable<ExpedienteVinculadoDto>{
    return  this.http.get<ExpedienteVinculadoDto>("/api/ExpedienteVinculado/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/ExpedienteVinculado/Delete?id=" + id);
    else
      return of(null)
  }

}
